import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { JourneyListSequence } from '../../../../components/journey-block-ui/journey-block-ui.component';

@Component({
    selector: 'app-journey-tips-popup',
    templateUrl: './journey-tips-popup.component.html',
    styleUrl: './journey-tips-popup.component.scss',
})
export class JourneyTipsPopupComponent implements OnInit, OnChanges {
    @Output() skipJourney: EventEmitter<void> = new EventEmitter<void>();
    @Output() nextJourney: EventEmitter<number> = new EventEmitter<number>();
    @Output() prevJourney: EventEmitter<number> = new EventEmitter<number>();

    @Input() arrowPosition: JourneyTipsArrowPosition = JourneyTipsArrowPosition.TopCenter;
    @Input() journeyArrayList: JourneyListSequence[] = [];
    @Input() isFirstStep = false;
    @Input() isLastStep = false;
    @Input() title = '';
    @Input() description = '';
    @Input() currentStep: JourneyListSequence = JourneyListSequence.Webinars;

    protected totalSteps = 0;
    protected triangleUiClass = '';

    ngOnInit(): void {
        this.initUiClass();
        this.initTotalStepsLength();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['currentStep']) {
            this.initUiClass();
        }
    }

    protected onSkipJourney(): void {
        this.skipJourney.emit();
    }

    protected onNextJourney(): void {
        this.nextJourney.emit();
    }

    protected onPrevJourney(): void {
        this.prevJourney.emit();
    }

    private initTotalStepsLength(): void {
        this.totalSteps = this.journeyArrayList.length;
    }

    private initUiClass(): void {
        switch (this.arrowPosition) {
            case JourneyTipsArrowPosition.TopLeft:
                this.triangleUiClass = 'arrow-top-left';

                break;
            case JourneyTipsArrowPosition.TopCenter:
                this.triangleUiClass = 'arrow-top-center';

                break;

            case JourneyTipsArrowPosition.TopRight:
                this.triangleUiClass = 'arrow-top-right';

                break;
            case JourneyTipsArrowPosition.BottomLeft:
                this.triangleUiClass = 'arrow-bottom-left';

                break;
            case JourneyTipsArrowPosition.BottomCenter:
                this.triangleUiClass = 'arrow-bottom-center';

                break;
            case JourneyTipsArrowPosition.BottomRight:
                this.triangleUiClass = 'arrow-bottom-right';

                break;
        }
    }
}

export enum JourneyTipsArrowPosition {
    TopLeft,
    TopCenter,
    TopRight,
    BottomLeft,
    BottomCenter,
    BottomRight,
}
